:host([light]) {
    & .es_database_g {
        stroke-width: 3.6px;
    }
    & .es_database_g,
    & .es_database_h,
    & .es_database_i,
    & .es_database_j,
    & .es_database_k,
    & .es_database_l,
    & .es_database_m,
    & .es_database_n {
        fill-rule: evenodd;
    }
    & .es_database_g,
    & .es_database_n {
        fill: none;
        stroke: #1b4e85;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .es_database_h {
        fill: #fff;
    }
    & .es_database_o {
        fill: #1b4e85;
    }
    & .es_database_i {
        fill: url(#es_database_c);
    }
    & .es_database_p {
        fill: #5cb253;
    }
    & .es_database_j {
        fill: url(#es_database_f);
    }
    & .es_database_k {
        fill: url(#es_database_b);
    }
    & .es_database_l {
        fill: url(#es_database_e);
    }
    & .es_database_m {
        fill: url(#es_database_d);
    }
    & .es_database_n {
        stroke-width: 14px;
    }
}
:host([dark]) {
    & .es_database_g {
        fill: #09264a;
    }
    & .es_database_h {
        stroke: #fff;
        stroke-width: 14px;
    }
    & .es_database_h,
    & .es_database_i {
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    & .es_database_h,
    & .es_database_i,
    & .es_database_j,
    & .es_database_k,
    & .es_database_l,
    & .es_database_m,
    & .es_database_n,
    & .es_database_o {
        fill-rule: evenodd;
    }
    & .es_database_i {
        stroke: #09264a;
        stroke-width: 3.6px;
    }
    & .es_database_j {
        fill: url(#es_database_c);
    }
    & .es_database_p {
        fill: #5cb253;
    }
    & .es_database_k {
        fill: url(#es_database_f);
    }
    & .es_database_l {
        fill: url(#es_database_b);
    }
    & .es_database_m {
        fill: url(#es_database_e);
    }
    & .es_database_n {
        fill: #ced4db;
    }
    & .es_database_o {
        fill: url(#es_database_d);
    }
}
